<div id="nova-ocorrencia" class="modal full" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" 
      aria-hidden="true" data-backdrop="static" data-keyboard="false">
<div class="modal-dialog modal-sm">
  <div class="modal-content" style="width: 600px;">
    <div class="modal-header">
      <h5 class="modal-title" id="exampleModalPopoversLabel"><img width="12px"  src="assets/imgs/clock-history.svg" alt=""> Nova Ocorrência </h5>
      <img data-dismiss="modal" class='bt-fechar' src="assets/imgs/icon_bt-limpar_header.svg" (click)="LimparCampos()">
    </div>
    <div class="modal-body">
      <h3>Motivo</h3>
      <select id="motivo" name="motivo" (ngModelChange)="onChangeObj($event)" [(ngModel)]="IdMotivo">
        <option value="o" disabled selected>Escolher Motivo</option>
        <option *ngFor="let item of listaMotivos" [value]="item?.IdMotivo">{{ item?.Descricao }}</option>
      </select>
      <label class="lblValMensagem" for="" *ngIf="(IdMotivo > 0) == false">{{ msgValMotivo }}</label>

       <div class="bloco">
          <h3>Observação</h3>
          <textarea name="observacao" id="observacao" rows="8" [(ngModel)]="Mensagem"></textarea>
       </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
      <button class="btn btn-primary" (click)="cadastraOcorrencia()" [ngClass]="{'p-0': loadingCriarOcorrencia}" [disabled]="loadingCriarOcorrencia" >
        <img  src="assets/imgs/loading2.gif"   *ngIf="loadingCriarOcorrencia" class="loading-cria-ocorrencia">
        <span class="pr-2">
          Criar Ocorrência
        </span>
       </button>
    </div>
  </div>
</div>

